import { Group } from '../services';
import { RoleRow } from '../types/role';

export function roleTransformGroups(groups: Group[]): RoleRow[] {
  return groups.map((group) => ({
    id: String(group.id),
    name: group.name,
    display_name: group.display_name || group.name,
    organization: group.organization_name || group.organization || '',
    organization_id: group.organization_id,
    members_count: group.user_count || group.members_count || 0,
    permissions_count:
      group.permission_codenames?.length || group.permissions_count || 0,
    permissions: group.permissions || [],
    permission_codenames: group.permission_codenames || [],
    is_system_role: group.is_system_role || false,
    description: group.description || '',
    status: group.is_system_role ? 'system' : 'active',
  }));
}
